import cx from 'classnames';

type KeywordItemProps = {
  rank: string;
  text: string;
  url: string;
};

type KeywordListProps = {
  data: KeywordItemProps[];
};

const KeywordItem = ({ rank, text, url }: KeywordItemProps) => {
  return (
    <li className="c-keyword__item">
      <a href={url} className="c-keyword__link">
        <span className={cx('c-keyword__number', Number(rank) <= 10 && 'c-keyword__number--emphasis')}>{rank}</span>
        <em className="c-keyword__keyword">{text}</em>
      </a>
    </li>
  );
};

const KeywordList = ({ data }: KeywordListProps) => {
  return (
    <ol className="c-keyword__list">
      {data.map(({ rank, text, url }, idx) => (
        <KeywordItem rank={rank} text={text} url={url} key={`keywordList-${idx}`} />
      ))}
    </ol>
  );
};

export default KeywordList;
